import React from "react";
import { RouteComponentProps } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import ConfirmPopup from "./ConfirmPopup";

interface SurchargeItem {
    id: number;
    itemId: number;
    item: string;
    amount: number;
    isDirty: boolean;
}

interface Item {
    id: number;
    name: string;
    defaultDays: number;
    typeId: number;
    overhireRequired: boolean;
}

const AdminSurchargeData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [chargeFuelSurcharge, setChargeFuelSurcharge] = React.useState(true);
    const [itemList, setItemList] = React.useState<Item[]>([]);
    const [surchargeItems, setSurchargeItems] = React.useState<SurchargeItem[]>([]);
    const [showDeleteConfirm, setShowDeleteConfirm] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState(-1);
    const [saveDisabled, setSaveDisabled] = React.useState(false);
    const [reloadData, setReloadData] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Admin/GetSurchargeData?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setItemList(res.data.itemOptions);
            setChargeFuelSurcharge(res.data.chargeFuelSurcharge);
            var scItems = res.data.surchargeItems;
            var blankItem = addBlankItem();
            scItems.push(blankItem);
            setSurchargeItems(scItems);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    React.useEffect(() => {
        if (reloadData) {
            setReloadData(false);
            window.scrollTo(0, 0);
            getSurchargeItemsList();
        }
    }, [reloadData]);

    const getSurchargeItemsList = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Admin/GetSurchargeItems?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var scItems = res.data;
            var blankItem = addBlankItem();
            scItems.push(blankItem);
            setSurchargeItems(scItems);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    React.useEffect(() => {
        if (!loading) {
            //save the fuel surcharge when it gets changed
            saveChargeSurcharge();
        }
    }, [chargeFuelSurcharge]);

    const addBlankItem = () => {
        var surcharge: SurchargeItem = {
            id: 0,
            itemId: -1,
            item: "",
            amount: 0,
            isDirty: false
        };
        return surcharge;
    }

    const clearError = (errorItem: string) => {
        let errorList = errors;
        delete errorList[errorItem];

        setErrors(errorList);
    }

    const handleCellItemChange = (e: any, index: number) => {
        clearError(e.target.name);

        let items = [...surchargeItems];
        var itemToUpdate = items[index];
        itemToUpdate.itemId = Number(e.target.value);
        itemToUpdate.isDirty = true;

        var itemDetails = itemList.find(i => i.id === Number(e.target.value));
        if (itemDetails) {
            itemToUpdate.item = itemDetails.name;
        }

        //check to see if we need to add a blank item
        var lastIndex = items.length - 1;
        if (lastIndex === index) {
            var blankItem = addBlankItem();
            items.push(blankItem);
        }

        setSurchargeItems(items);
    }

    const handleCellAmountChange = (e: any, index: number) => {
        clearError(e.target.name);

        let items = [...surchargeItems];
        var itemToUpdate = items[index];
        itemToUpdate.amount = Number(e.target.value);
        itemToUpdate.isDirty = true;

        //check to see if we need to add a blank item
        var lastIndex = items.length - 1;
        if (lastIndex === index) {
            var blankItem = addBlankItem();
            items.push(blankItem);
        }

        setSurchargeItems(items);
    }

    //DELETE Item
    const deleteItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        setShowDeleteConfirm(true);
        setDeleteIndex(itemIndex);
    }

    const hideDeleteConfirm = () => {
        setShowDeleteConfirm(false);
        setDeleteIndex(-1);
    }

    const saveDeleteConfirm = () => {
        saveDeleteSurchargeItem();
    }

    const saveDeleteSurchargeItem = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var surchageItemList = [...surchargeItems];
        var itemToDelete = surchageItemList[deleteIndex];

        var deleteItemSave = {
            id: itemToDelete.id,
            subId: user.sub
        };

        axios.post('api/Admin/DeleteSurchargeItem', deleteItemSave, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("File Deleted Successfully");
                setShowDeleteConfirm(false);
                setDeleteIndex(-1);
                setReloadData(true);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        var rowNumber = 0;
        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < surchargeItems.length - 1; i++) {
            var item = surchargeItems[i];
            rowNumber += 1;
            var newErrorString = "";

            if (item.itemId < 1) {
                newErrorString += "Item, ";
                error = true;
            }

            if (item.amount <= 0) {
                newErrorString += "Amount, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }
        if (error) {
            formIsValid = false;
            errorList["surchargeItems"] = errorString;
        }
        setErrors(errorList);
        return formIsValid;
    }

    const saveSurcharge = () => {
        if (validate()) {
            setSaveDisabled(true);
            if (saveDisabled) {
                return;
            }

            var changed = surchargeItems.filter(p => p.isDirty);
            if (changed.length === 0) {
                toast.info("No items have changed.");
                setSaveDisabled(false);
            } else {
                saveSurchargeItems();
            }
        } else {
            toast.error("Fix validation errors on screen before saving!");
        }
    }

    const saveSurchargeItems = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var surchageItemList = [...surchargeItems];
        var itemsToSave = surchageItemList.filter(f => f.isDirty);

        var itemSave = {
            chargeFuelSurcharge: chargeFuelSurcharge,
            surchargeItems: itemsToSave,
            subId: user.sub
        };

        axios.post('api/Admin/SaveSurchargeItem', itemSave, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
                setSaveDisabled(false);
            } else {
                toast.success("Item/s Saved Successfully");
                setSurchargeItems([]);
                setReloadData(true);
                setSaveDisabled(false);
            }
        })
        .catch(error => {
            toast.error(error.message);
            setSaveDisabled(false);
        });
    }

    const saveChargeSurcharge = async () => {
        const token = await authService.getAccessToken();

        var itemSave = {
            chargeFuelSurcharge: chargeFuelSurcharge,
        };

        axios.post('api/Admin/SaveChargeFuelSurcharge', itemSave, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
                setSaveDisabled(false);
            } else {
                toast.success("Charge Fuel Surcharge Saved Successfully");
                setSaveDisabled(false);
            }
        })
        .catch(error => {
            toast.error(error.message);
            setSaveDisabled(false);
        });
    }
    

    const confirmPopup = <ConfirmPopup heading="Delete Surcharge Item?" text="Are you sure you want to delete this surcharge item?" hideConfirmModal={hideDeleteConfirm} showConfirmModal={showDeleteConfirm} saveConfirmModal={saveDeleteConfirm} />

    const renderDetails = (
        <div>
            <div className="static-modal">
                {confirmPopup}
            </div>

            <div>
                <label className="input-group" htmlFor="chargeFuelSurcharge">
                    <span className="label">Charge Fuel Surcharge</span>
                    <input className="checkbox" type="checkbox" id="chargeFuelSurcharge" name="chargeFuelSurcharge" checked={chargeFuelSurcharge} onClick={() => setChargeFuelSurcharge(!chargeFuelSurcharge)} ></input>
                </label>
            </div>

            <div className="overflowAuto">
                <table className="table table--nowidth tableColours">
                    <thead>
                        <tr>
                            <th className="hidden">Id</th>
                            <th>Item</th>
                            <th>Amount</th>
                            <th></th>
                        </tr>
                    </thead>
                    {surchargeItems.map((item, index) =>
                        <tbody key={item.id}>
                            <tr>
                                <td className="hidden">{item.id}</td>
                                <td className="table__text--align">
                                    <select className="select" id="itemId" name="itemId" value={item.itemId} onChange={(e) => handleCellItemChange(e, index)} disabled={item.id > 0}>
                                        <option defaultValue="-1"></option>
                                        {itemList.map(item =>
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        )};
                                    </select>
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='form-control textalignright' id="amount" name="amount" value={item.amount} onChange={(e) => handleCellAmountChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <div className={(index === surchargeItems.length - 1) ? "hidden" : "delete--tablecell"}>
                                        <a className="makeitred" href="#" onClick={(e) => deleteItem(e, index)}>
                                            <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
                {errors["surchargeItems"] ?
                    (errors["surchargeItems"]).split("\n").map((item: any, key: any) => {
                        return <span className="label errors" key={key}>{item}<br /></span>
                    })
                    : ""}
            </div>
            <div className="marginBottom10">
                <button className="defaultbutton defaultbutton__large" type="button" onClick={saveSurcharge} >Save</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Fuel Surcharge Items</h1>
            {contents}
        </div>
    );

}

export default AdminSurchargeData;